import React from 'react';
import SignUpPage from '../components/signUp-LogIn/SignUpPage';

export default function SignUp() {
  return (
    <div className="min-h-screen">
      <SignUpPage />
    </div>
  );
}
